import React from "react";
import { Layout } from "antd";
import { FactoryPathUrl } from "../../../utils/common";
import { useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import AppHeader from "./AppHeader";
import AppContent from "./AppContent";
import LokiErrorToast from '../../../view/general/LokiErrorToast_ws'
import { LOGS } from '../../../utils/constants'
import { useParams, useLocation } from "react-router-dom";
import type {RootState} from "../../../store";
const { Content } = Layout;

interface MainLayoutProps {
    permittedCustomers: any[];
    loading: boolean;
    loadingLogout: boolean;
    authLoading: boolean;
    loginStatus: string;
    permittedCustomersLoading: boolean;
    permittedCustomersError: string;
    customerSitesLoading: boolean;
    FactoryPath: boolean;
    showOutlet: boolean;
    presentComponents: any;
    isMobile: boolean;
    children: React.ReactNode;
    isNewIndustry: boolean
}

export default function MainLayout({
    permittedCustomers,
    loading,
    loadingLogout,
    authLoading,
    loginStatus,
    permittedCustomersLoading,
    permittedCustomersError,
    customerSitesLoading,
    FactoryPath,
    showOutlet,
    presentComponents,
    isMobile,
    children,
    isNewIndustry
}: MainLayoutProps) {
    const shouldShowLayout =
        permittedCustomers.length > 0 &&
        !loading &&
        !loadingLogout &&
        !(!loadingLogout && !authLoading && loginStatus !== "error" &&
            !permittedCustomersLoading && permittedCustomers.length === 0 &&
            permittedCustomersError?.length === 0) &&
        !(!((loadingLogout === false && loginStatus === "success") || customerSitesLoading ||
            (FactoryPathUrl(FactoryPath) && loadingLogout === false && loginStatus === "success")) &&
            ((permittedCustomersLoading && permittedCustomersError.length === 0) || authLoading));
          
const {  selectedCustomerName, customerSites, selectedSite } = useSelector((state: RootState) => state.userInfo);
const { site } = useParams();
const location = useLocation();
 // Permission checks for LokiErrorToast
 const currentSiteName = site || selectedSite || '';
 const siteObj = customerSites.find((s: any) => s.name === currentSiteName);
 const siteAllowsLogs = !!siteObj?.preferences?.present_components?.includes(LOGS);
 const customerAllowsLogs = !!permittedCustomers.find((c: any) => c.customer === selectedCustomerName)?.preferences?.globalLogs;
 const hasSite = !!currentSiteName; // site present => enforce site-level permission only
 const isOnLogsPage = location.pathname.includes('/Logs');
 const showLokiToast = (hasSite ? siteAllowsLogs : customerAllowsLogs) && !isOnLogsPage;
 
    if (!shouldShowLayout) return null;

    return (
        <Layout>
            <Sidebar
                isNewIndustry={isNewIndustry}
                isMobile={isMobile}
                presentComponents={presentComponents}
            />

            <Layout style={{ height: "inherit" }}>
                <AppHeader isMobile={isMobile} isNewIndustry={isNewIndustry} />

                <Content className="content">
                    {showLokiToast && (
                        <LokiErrorToast />
                    )}
                    <AppContent
                        customerSitesLoading={customerSitesLoading}
                        showOutlet={showOutlet}
                    >
                        {children}
                    </AppContent>
                </Content>
            </Layout>
        </Layout>
    );
}